import Vue from 'vue'
import axios from 'axios'
import moment from 'moment'
import Oidc from 'oidc-client'

import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/en'
import 'element-ui/lib/theme-chalk/index.css'

import { App } from './app'
import router from './router'

import { GlobalApp } from './globalapp'
import VueTheMask from 'vue-the-mask'
import i18n from './i18n'
Vue.use(VueTheMask);

Vue.config.productionTip = false

Vue.filter('money',
    function (value) {
        if (!value) return '$0.00';
        value = parseFloat(value).toFixed(2);
        return '$' + value;
    });

Vue.filter('date',
    function (value) {
        if (value) {
            return moment(String(value)).format('YYYY/MM/DD');
        }
    });
Vue.filter('datetime',
    function (value) {
        if (value) {
            return moment(String(value)).format('YYYY/MM/DD HH:mm');
        }
    });

Vue.use(ElementUI, { locale });
require('es6-promise').polyfill();
//require('babel-polyfill')
axios.download = function (url, params) {
    return axios.get(url,
        {
            responseType: 'arraybuffer',
            params: params
        }).then(response => {
            const blob = new Blob([response.data], { type: response.headers['content-type'] });
            const link = document.createElement('a');
            document.body.appendChild(link);
            link.href = window.URL.createObjectURL(blob);
            const matches = /filename=(.*?)(;|$)/g.exec(response.headers['content-disposition']);
            link.download = matches && matches.length > 1 ? matches[1].replace(/"/g, '') : null;
            link.click();
            document.body.removeChild(link);
        });
}
const unAuthorizedUrls = {
    EscalationTickets: "escalation-tickets",
}

var manager = new Oidc.UserManager({
    userStore: new Oidc.WebStorageStateStore(),
    authority: window.authentication.authority,
    client_id: window.authentication.clientId,
    redirect_uri: window.authentication.redirectUrl,
    response_type: 'id_token token',
    scope: 'openid profile email api',
    post_logout_redirect_uri: window.authentication.authority,
    loadUserInfo: true,
    silent_redirect_uri: window.location.origin + "/static/silent.html",
    automaticSilentRenew: true
});

manager.getUser().then(function (user) {
    var pathSegments = window.location.pathname.split('/');
    // If using a hash URL
    var hashSegment = window.location.hash.split('/').pop();

    if (hashSegment === unAuthorizedUrls.EscalationTickets) {
        new Vue({
            i18n,
            el: '#app',
            router,
            render: h => h(GlobalApp)
        });
    }
    else {
        if (localStorage.getItem("browserClosed")) {
            document.cookie = "browserClosed=" + localStorage.getItem("browserClosed");
        }
    if (user === null) {
        validNavigation = true;
        manager.signinRedirect();
        console.log("Testing");
    } else {
        user.profile.role = user.profile.role.toLowerCase();
        axios.defaults.headers.common['Authorization'] = `Bearer ${user.access_token}`;
        Vue.prototype.$currentUser = user;
        Vue.prototype.$isAdmin = user.profile.role === 'admin';
        Vue.prototype.$isReadonlyAdmin = Vue.prototype.$isAdmin && user.profile.readonly;
        Vue.prototype.$isFullAdmin = Vue.prototype.$isAdmin && !user.profile.readonly;
        Vue.prototype.$isSuperAdmin = Vue.prototype.$isAdmin && user.profile.superAdmin;
        Vue.prototype.$isSubAgentUser = user.profile.role === 'subagentuser';
        console.log(Vue.prototype.$isSubAgentUser);
        Vue.prototype.$isUser = user.profile.role === 'user';
        Vue.prototype.$isImpersonateUser = localStorage["isImpersonateUser"] === "true";
        console.log(Vue.prototype.$isUser);
        console.log("Testing");

        /* eslint-disable no-new */
        new Vue({
            i18n,
            el: '#app',
            router,
            render: h => h(App)
        });
        }
        i18n.locale = 'en'
    }
})
    .catch(function (err) {
        console.log(err);
    });


var validNavigation = false;

window.addEventListener('beforeunload', function (event) {
    if (!validNavigation) {
        //localStorage.clear();
        //document.cookie = "browserClosed=" + new Date().getTime();
        //localStorage.setItem("browserClosed", new Date().getTime());
    }
});
window.signInManager = manager;


// WEBPACK FOOTER //
// ./ClientApp/main.js